import React, { Component } from 'react'
import Helmet from 'react-helmet'
import styled, { keyframes, injectGlobal } from 'styled-components'
import { withPrefix } from 'gatsby-link'
import { Provider, observer } from 'mobx-react'

import store from '../store/'
import Footer from '../components/Footer'
import Background from '../components/Background'

console.log('Design made with ❤️ by www.fabienlaborie.com')

const background = withPrefix('/images/noise.png')
const CallingCodeTTF = withPrefix('../fonts/CallingCode-Regular.ttf')

const noise = keyframes`
0%, 100% {
  background-position: 0 0;
}

10% {
  background-position: -5% -10%;
}

20% {
  background-position: -15% 5%;
}

30% {
  background-position: 7% -25%;
}

40% {
  background-position: 20% 25%;
}

50% {
  background-position: -25% 10%;
}

60% {
  background-position: 15% 5%;
}

70% {
  background-position: 0% 15%;
}

80% {
  background-position: 25% 35%;
}

90% {
  background-position: -10% 10%;
}
`

injectGlobal`
  body {
    margin: 0;

    color: #3E0963;

    font-family: "CallingCode-Regular";
  }

  html {
    position: relative;

    box-sizing: border-box;

    &:before {
      content: '';

      z-index: 100;
      position: absolute;
      top: 0;
      left: 0;

      width: 100%;
      height: 100%;

      background-image: url(${background});

      animation: 1s infinite ${noise};

      pointer-events: none;
    }
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }


  a:link{color:inherit}
  a:active{color:inherit}
  a:visited{color:inherit}
  a:hover{color:inherit}
`

const Container = styled.div`
  display: flex;
  flex-flow: column;

  background-color: ${props => props.backgroundColor};

  transition: background-color 0.3s ease-in-out;
`

@observer
export default class Layout extends Component {
  render() {
    return (
      <Provider store={store}>
        <div>
          <Helmet
            title={this.props.data.site.siteMetadata.title}
            meta={[
              {
                name: 'description',
                content:
                  ' I am a Consultant Front-End Developer passionate about new technologies and languages​. I have been able to develop skills focused on efficiency and on communication. Whether for the analysis of a project or design, I consider it imperative to have a final product easy to maintain, easy to use and elegan.',
              },
              {
                name: 'keywords',
                content:
                  'Html, Css, Javascript, React, React Native, Elm, GraphQL + Apollo, TypeScript',
              },
            ]}
          />

          <Background />
          <Container backgroundColor={store.backgroundColor}>
            {this.props.children()}
          </Container>
          <Footer />
        </div>
      </Provider>
    )
  }
}

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js